module.exports = __webpack_public_path__ + "img/rumor-logo.8c035a25.png";